export default __webpack_public_path__ + "static/media/AuthSlideThree.7e09a94b.svg";